import { DateTime } from 'luxon';
import React from 'react';
import styles from '../../styles/lineItem.module.scss';
import { GiftCardDelivery } from '../../types';
import { useTranslation } from 'react-i18next';

export default function GiftCardInformation({ delivery }: { delivery: GiftCardDelivery }) {
  const { t } = useTranslation();
  let deliveryDate = t('right_away');
  if (delivery.deliverAt) {
    deliveryDate = DateTime.fromISO(delivery.deliverAt).toLocaleString(DateTime.DATE_SHORT);
  }

  return (
    <div className={styles.giftCardDeliveryInformation}>
      <div className={styles.giftLine}>{delivery.emailAddress}</div>
      <div className={styles.giftLine}>{t('delivery_date', { date: deliveryDate })}</div>
    </div>
  );
}
